import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';

function getStyle(el, prop) {
  if (prop in el.style) {
    var style = el.style.getPropertyValue(prop);

    if (style) {
      return style;
    }
  }

  if (window.getComputedStyle) {
    return window.getComputedStyle(el, null).getPropertyValue(prop);
  }

  if ('currentStyle' in el) {
    return el.currentStyle[prop];
  }

  return undefined;
}

function css(dom, type, value) {
  if (typeof value === 'undefined') {
    return getStyle(dom, type);
  }

  var styleProps = dom.style;

  if (value) {
    styleProps[type] = value;
  } else {
    styleProps[type] = '';
    delete styleProps[type];
  }

  return value;
}
function on(dom, events, listener) {
  var eventsArr = events.split(' ');
  eventsArr.forEach(function (type) {
    if (type) {
      dom.addEventListener(type, listener, false);
    }
  });
}
function off(dom, events, listener) {
  var eventsArr = events.split(' ');
  eventsArr.forEach(function (type) {
    if (type) {
      dom.removeEventListener(type, listener);
    }
  });
}
function parentUntil(dom, className) {
  var _context;

  if (_includesInstanceProperty(_context = dom.className.split(' ')).call(_context, className)) {
    return dom;
  }

  if (dom.parentElement) {
    return parentUntil(dom.parentElement, className);
  }

  return null;
}
function preventEvent(e) {
  var _context2;

  var target = e.target;

  if (target && (_includesInstanceProperty(_context2 = target.className.split(' ')).call(_context2, 'draggable') || parentUntil(target, 'draggable'))) {
    e.preventDefault();
  }
}
function isMobileView() {
  var MOBILE_VIEWPORT_WIDTH_SPLIT_POINT = 480;
  return document.body.offsetWidth <= MOBILE_VIEWPORT_WIDTH_SPLIT_POINT;
}

export { css, isMobileView, off, on, parentUntil, preventEvent };
